import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import debounce from "lodash/debounce";
import useApi from "../../hook/useApi";
import Paggination from "../Paggination";
import Loader from "../Loader/Loader";
import { copyToClipboard, trimAddress } from "../../utils/helper";
import { IoCopyOutline } from "react-icons/io5";
import { AIRDROP_STATUS } from "../../utils/constant";

const AirdropTransactionsLayer = () => {
     const { AsyncGetApiCall } = useApi();
     const navigate = useNavigate();
     const [query, setQuery] = useState({
          pageNo: 1,
          limitVal: 50,
          search: "",
          status: ""
     });
     const [loading, setLoading] = useState(false);
     const [data, setData] = useState([]);

     const setPageNo = (pageNo) => {
          setQuery((prev) => ({
               ...prev,
               pageNo: pageNo,
          }));
     };

     const getAllAirdropList = async (showLoader = true) => {
          try {
               if (showLoader) {
                    setLoading(true);
               }
               const result = await AsyncGetApiCall("/airdrop/list", query);

               if (result?.success) {
                    setData(result || []);
               } else {
                    toast.error(result?.message || "Failed to fetch airdrop data");
               }
          } catch (error) {
               console.log("error...", error);
          }
          finally {
               if (showLoader) {
                    setLoading(false);
               }
          }
     };

     // Optional: Add view action if you have a route to view airdrop details
     const handleViewAirdrop = (id) => {
          navigate(`/view-airdrop-tx/${id}`);
     };

     const handleSearchAirdrop = (e) => {
          const value = e.target.value;
          const validChars = /^[a-zA-Z0-9]*$/;; // Only alphanumeric characters allowed

          if (validChars.test(value)) {
               //   console.log("Only letters and numbers are allowed.");
               setQuery((prev) => ({ ...prev, search: value, pageNo: 1 }));
          }
     };

     // Prevent form submission
     const handleFormSubmit = (e) => {
          e.preventDefault();
     };

     const handleStatusChange = (e) => {
          const value = e.target.value;
          setQuery((prev) => ({
               ...prev,
               status: value === "Select Status" ? "" : value,
               pageNo: 1,
          }));
     };

     useEffect(() => {
          getAllAirdropList(false);
     }, [query]);

     return (
          <>
               {loading && <Loader />}
               <div className="card h-100 p-0 radius-12">
                    <div className="card-header border-bottom bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
                         <div className="d-flex align-items-center flex-wrap gap-3">
                              <span className="text-md fw-medium text-secondary-light mb-0">
                                   Show
                              </span>
                              <select
                                   className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                   value={query.limitVal}
                                   onChange={(e) => {
                                        const value = parseInt(e.target.value, 10);
                                        setQuery((prev) => ({
                                             ...prev,
                                             limitVal: value,
                                             pageNo: 1,
                                        }));
                                   }}
                              >
                                   {Array.from({ length: 20 }, (_, i) => {
                                        const value = (i + 1) * 5;
                                        return (
                                             <option key={value} value={value}>
                                                  {value}
                                             </option>
                                        );
                                   })}
                              </select>
                              <form className="navbar-search" onSubmit={handleFormSubmit}>
                                   <input
                                        type="text"
                                        className="bg-base h-40-px w-auto"
                                        name="search"
                                        placeholder="Search airdrops"
                                        onChange={handleSearchAirdrop}
                                        value={query.search}
                                   />
                                   <Icon icon="ion:search-outline" className="icon" />
                              </form>
                              <span className="text-md fw-medium text-secondary-light mb-0">
                                   Status
                              </span>
                              <select
                                   name="status"
                                   id="status"
                                   className="form-select form-select-sm w-auto ps-12 py-6 radius-12 h-40-px"
                                   value={query.status || "Select Status"}
                                   onChange={handleStatusChange}>
                                   <option value="Select Status">Select Status</option>
                                   <option value={AIRDROP_STATUS.SUCCESS}>Success</option>
                                   <option value={AIRDROP_STATUS.PENDING}>Pending</option>
                                   <option value={AIRDROP_STATUS.FAILED}>Failed</option>
                              </select>
                         </div>
                    </div>

                    <div className="card-body p-24">
                         <div className="table-responsive scroll-sm">
                              <table className="table bordered-table sm-table mb-0">
                                   <thead>
                                        <tr>
                                             <th scope="col">
                                                  <div className="d-flex align-items-center gap-10">
                                                       <div className="form-check style-check d-flex align-items-center"></div>
                                                       S.No
                                                  </div>
                                             </th>
                                             <th scope="col">Merkle Root</th>
                                             <th scope="col">Receiver</th>
                                             <th scope="col">Quantity</th>
                                             <th scope="col">Status</th>
                                             <th scope="col">Date</th>
                                             <th scope="col" className="text-center">
                                                  Action
                                             </th>
                                        </tr>
                                   </thead>
                                   <tbody>
                                        {data?.data && data?.data?.length > 0 ? (
                                             data?.data?.map((airdrop, index) => (
                                                  <tr key={airdrop._id}>
                                                       <td>
                                                            <div className="d-flex justify-content-center align-items-center gap-10">
                                                                 {(data?.pagination?.currentPage - 1) * query.limitVal + index + 1}
                                                            </div>
                                                       </td>
                                                       <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                 {trimAddress(airdrop.merkleRoot, 6, 6)}
                                                                 <button
                                                                      onClick={() => copyToClipboard(airdrop.merkleRoot)}
                                                                      className="ms-3 p-0 border-0 bg-transparent"
                                                                      style={{ lineHeight: 1 }}
                                                                 >
                                                                      <IoCopyOutline />
                                                                 </button>
                                                            </span>
                                                       </td>
                                                       <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                 {trimAddress(airdrop.receiver, 6, 6)}
                                                                 <button
                                                                      onClick={() => copyToClipboard(airdrop.receiver)}
                                                                      className="ms-3 p-0 border-0 bg-transparent"
                                                                      style={{ lineHeight: 1 }}
                                                                 >
                                                                      <IoCopyOutline />
                                                                 </button>
                                                            </span>
                                                       </td>
                                                       <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                 {airdrop.quantity}
                                                            </span>
                                                       </td>
                                                       <td>
                                                            <span
                                                                 className={`badge ${airdrop.status === AIRDROP_STATUS.SUCCESS
                                                                      ? 'bg-success-100 text-success-600'
                                                                      : airdrop.status === AIRDROP_STATUS.PENDING
                                                                           ? 'bg-warning-100 text-warning-600'
                                                                           : airdrop.status === AIRDROP_STATUS.FAILED
                                                                                ? 'bg-danger-100 text-danger-600'
                                                                                : 'background-gray-100'
                                                                      } text-sm py-4 px-10 radius-4`}
                                                            >
                                                                 {airdrop?.status?.toUpperCase()}
                                                            </span>
                                                       </td>
                                                       <td>
                                                            <span className="text-md mb-0 fw-normal text-secondary-light">
                                                                 {new Date(airdrop?.createdAt).toLocaleString("en-GB", {
                                                                      day: "2-digit",
                                                                      month: "2-digit",
                                                                      year: "numeric",
                                                                      hour: "2-digit",
                                                                      minute: "2-digit",
                                                                      second: "2-digit",
                                                                      hour12: true,
                                                                 })}
                                                            </span>
                                                       </td>
                                                       <td className="text-center">
                                                            <div className="d-flex align-items-center gap-10 justify-content-center">
                                                                 <button
                                                                      type="button"
                                                                      className="bg-info-focus bg-hover-info-200 text-info-600 fw-medium w-40-px h-40-px d-flex justify-content-center align-items-center rounded-circle"
                                                                      onClick={() => handleViewAirdrop(airdrop._id)}
                                                                 >
                                                                      <Icon
                                                                           icon="majesticons:eye-line"
                                                                           className="icon text-xl"
                                                                      />
                                                                      <span className="tooltip-text">View</span>
                                                                 </button>
                                                            </div>
                                                       </td>
                                                  </tr>
                                             ))
                                        ) : (
                                             <tr>
                                                  <td colSpan="7" className="text-center">
                                                       No airdrop transactions found
                                                  </td>
                                             </tr>
                                        )}
                                   </tbody>
                              </table>
                         </div>
                         <Paggination
                              total={data?.pagination?.total || 0}
                              totalPages={data?.pagination?.totalPages || 0}
                              currentPage={data?.pagination?.currentPage || 0}
                              setPageNo={setPageNo}
                              startFrom={(data?.pagination?.currentPage - 1) * query.limitVal + 1}
                              endTo={
                                   (data?.pagination?.currentPage - 1) * query.limitVal +
                                   data?.data?.length
                              }
                         />
                    </div>
               </div>
          </>
     );
};

export default AirdropTransactionsLayer;